import React from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  useMediaQuery,
  useTheme,
} from "@mui/material";

type AuthLayoutProps = {
  children: React.ReactNode;
};

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isMobile) {
    return (
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          paddingX: 2,
          paddingY: 4,
          display: "flex",
          flexDirection: "column",
          bgcolor: "white",
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="sm" sx={{ p: { xs: 0 } }}>
        <Card
          sx={{
            width: "100%",
            py: 4,
            px: {
              xs: 2,
              sm: 4,
            },
          }}
        >
          <CardContent>{children}</CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default AuthLayout;
